module.exports = __webpack_public_path__ + "img/baner2.d6d3b82b.png";